import { ZonedDateTime } from "@js-joda/core"
import { BloodGlucoseForm, BloodGlucoseFormApiDto, toBloodGlucoseForm } from "./BloodGlucoseForm"
import {
  BloodGlucoseReading,
  BloodGlucoseReadingApiDto,
  toBloodGlucoseReading,
} from "./BloodGlucoseReading"

export type BloodGlucoseObservationApiDto = {
  dateTime: string // ISO 8601 with offset
  reading: BloodGlucoseReadingApiDto | null
  form: BloodGlucoseFormApiDto | null
  isFormEditable: boolean
  note: string | null
}

export type BloodGlucoseObservationWithReadingApiDto = Omit<
  BloodGlucoseObservationApiDto,
  "reading"
> & {
  reading: BloodGlucoseReadingApiDto
}

export type BloodGlucoseObservation = {
  dateTime: ZonedDateTime
  reading: BloodGlucoseReading | null
  form: BloodGlucoseForm | null
  isFormEditable: boolean
  note: string | null
}

export type BloodGlucoseObservationWithReading = Omit<BloodGlucoseObservation, "reading"> & {
  reading: BloodGlucoseReading
}

export const toBloodGlucoseObservation = (
  dto: BloodGlucoseObservationApiDto,
): BloodGlucoseObservation => ({
  dateTime: ZonedDateTime.parse(dto.dateTime),
  reading: dto.reading ? toBloodGlucoseReading(dto.reading) : null,
  form: dto.form ? toBloodGlucoseForm(dto.form) : null,
  isFormEditable: dto.isFormEditable,
  note: dto.note ?? null,
})

export const toBloodGlucoseObservationWithReading = (
  dto: BloodGlucoseObservationWithReadingApiDto,
): BloodGlucoseObservationWithReading => ({
  dateTime: ZonedDateTime.parse(dto.dateTime),
  reading: toBloodGlucoseReading(dto.reading),
  form: dto.form ? toBloodGlucoseForm(dto.form) : null,
  isFormEditable: dto.isFormEditable,
  note: dto.note ?? null,
})
